import React from 'react'
import classNames from 'classnames'
import { Image } from '~/components/Image'
import styles from './TagImage.module.scss'
import { TagImageProps } from './TagImage.types'

function TagImage({ title, href }: TagImageProps) {
  return (
    <span className={classNames(styles.tagImage)}>
      <Image src={href} className='w-full h-full' alt={title} />
    </span>
  )
}

export default TagImage
